import { FormEvent, useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useAuth } from "../contexts/auth-context";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSearch } from "@fortawesome/free-solid-svg-icons";

const NavbarSearch = () => {
  const { isShopAdmin, isShopUser, isMobileResolution } = useAuth();
  const { pathname, search } = useLocation();
  const isTableOrderRoute = pathname.includes("/tbl-orders");
  const currentSearchTerm = new URLSearchParams(search).get("search") ?? "";
  const [searchTerm, setSearchTerm] = useState(currentSearchTerm);
  const navigate = useNavigate();

  useEffect(() => {
    setSearchTerm(currentSearchTerm);
  }, [currentSearchTerm]);

  const submitSearch = (event: FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    const term = searchTerm.trim();

    if (isTableOrderRoute) {
      const query = new URLSearchParams(search);
      if (term) query.set("search", term);
      else query.delete("search");

      // Keep the selected table (and any other ordering context) while the
      // menu is filtered, rather than sending staff to product management.
      const queryString = query.toString();
      navigate(queryString ? `${pathname}?${queryString}` : pathname, {
        replace: true,
      });
      return;
    }

    if (!term) return;
    const destination =
      isShopAdmin || isShopUser ? "/manage-products" : "/prods";
    navigate(`${destination}?search=${encodeURIComponent(term)}`, {
      replace: true,
    });
  };

  return (
    <form
      className={`d-flex ms-auto ${
        isTableOrderRoute ? "table-order-search" : ""
      }`}
      role="search"
      onSubmit={submitSearch}
      title={
        isTableOrderRoute
          ? "Search menu items without leaving this dine-in order"
          : "Search products"
      }
    >
      <div className="input-group">
        <input
          style={
            isMobileResolution
              ? {
                  height: "40px",
                  width: isTableOrderRoute ? "180px" : "110px",
                }
              : { height: "40px" }
          }
          className="form-control"
          name="search"
          placeholder={
            isTableOrderRoute ? "Search items for this order…" : "Search products…"
          }
          aria-label={
            isTableOrderRoute
              ? "Search menu items for this dine-in order"
              : "Search products"
          }
          type="search"
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
        />
        <button
          className="btn bg-white"
          type="submit"
          aria-label="Search menu"
        >
          <FontAwesomeIcon icon={faSearch} />
        </button>
      </div>
    </form>
  );
};

export default NavbarSearch;
